var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptionCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 0C10.6543 0 6.96611 1.52751 4.24743 4.24743C1.52748 6.96617 0 10.6543 0 14.5C0 18.3457 1.52751 22.0339 4.24743 24.7526C6.96617 27.4725 10.6543 29 14.5 29C18.3457 29 22.0339 27.4725 24.7526 24.7526C27.4725 22.0338 29 18.3457 29 14.5C29 10.6543 27.4725 6.96611 24.7526 4.24743C22.0338 1.52748 18.3457 0 14.5 0ZM22.2567 8.99092L14.2005 20.2689C13.9251 20.654 13.4946 20.8997 13.0224 20.939C12.9771 20.9426 12.933 20.9438 12.8889 20.9438C12.4608 20.9438 12.0518 20.7745 11.7501 20.4716L6.91592 15.6386C6.51526 15.2308 6.36025 14.6406 6.5105 14.0885C6.66075 13.5364 7.0912 13.1047 7.6433 12.9557C8.1954 12.8054 8.78566 12.9605 9.19346 13.3611L12.6826 16.849L19.6335 7.11878C19.9674 6.65014 20.5266 6.39616 21.1002 6.45101C21.6725 6.50586 22.1733 6.86361 22.4118 7.38707C22.6503 7.91054 22.5918 8.52231 22.2567 8.99092Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionCheckmark);
export default __webpack_public_path__ + "static/media/option-checkmark.bbea38e57df7fadbed1b2542f9e53b38.svg";
export { ForwardRef as ReactComponent };